module.exports = __webpack_public_path__ + "static/media/icon-cog-outline.79f97c22.svg";